var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boxesContainer widthFull mb-4" }, [
    _c(
      "div",
      { staticClass: "cardBox mb-4", class: { "is-flipped": _vm.card4 } },
      [
        _c("div", { staticClass: "cardFlow" }, [
          _c("div", { staticClass: "front vaillantCont" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticClass: "mt-0 pt-0",
                class: {
                  "pb-md-0": _vm.aeState == "pending" || _vm.aeState == "active"
                }
              },
              [
                _c("b", [
                  _vm._v(" Stato:\n            "),
                  _vm.aeState == "not_active"
                    ? _c("span", { staticClass: "grey" }, [
                        _vm._v(" Non Abilitato ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "not_active"
                    ? _c(
                        "span",
                        {
                          staticClass: "mt-3 btn btn-secondary btn-sm ml-4",
                          staticStyle: { "vertical-align": "unset" },
                          on: {
                            click: function($event) {
                              return _vm.setSection(3)
                            }
                          }
                        },
                        [_vm._v(" ABILITA\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "pending"
                    ? _c("span", { staticClass: "yellow " }, [
                        _vm._v(" Documentazione in verifica ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "await_contract"
                    ? _c("span", { staticClass: "yellow " }, [
                        _vm._v(" In attesa del Contratto ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "error"
                    ? _c("span", { staticClass: "red" }, [
                        _vm._v(" Rilevato anomalia/e")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "error"
                    ? _c(
                        "span",
                        {
                          staticClass: "mt-3 btn btn-secondary btn-sm ml-4",
                          staticStyle: { "vertical-align": "unset" },
                          on: {
                            click: function($event) {
                              return _vm.setSection(3)
                            }
                          }
                        },
                        [_vm._v(" SCOPRI DI PIÙ\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "renew"
                    ? _c("span", { staticClass: "red" }, [_vm._v(" Sospeso ")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "renew"
                    ? _c(
                        "span",
                        {
                          staticClass: "mt-3 btn btn-secondary btn-sm ml-4",
                          staticStyle: { "vertical-align": "unset" },
                          on: {
                            click: function($event) {
                              return _vm.setSection(3)
                            }
                          }
                        },
                        [_vm._v("\n              SCOPRI DI PIÙ\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.aeState == "active"
                    ? _c("span", { staticClass: "green  " }, [
                        _vm._v(" Abilitato ")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row justify-content-center text-center" },
                [
                  _c(
                    "div",
                    { staticClass: "col-6 center text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue mt-2 pt-0 mb-0 center h2 "
                            },
                            [
                              _c("b", {}, [
                                _vm._v(
                                  _vm._s(100 - _vm.finance_cost_agileenergy) +
                                    "%"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _vm._m(3)
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c(
                          "h1",
                          {
                            staticClass: "quardValue mt-0 pt-2 mb-0 center h2 "
                          },
                          [
                            _c("b", {}, [
                              _vm._v(
                                " € " +
                                  _vm._s(_vm.practic_price_agileenergy_old)
                              ),
                              _vm._m(4)
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(5)
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue center h2  mt-2 pt-0 mb-0"
                            },
                            [
                              _c(
                                "b",
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "user-check", size: "1x" }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(6)
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue  mt-2 pt-0 mb-0 center h2 "
                            },
                            [
                              _c("b", [
                                _vm._v(
                                  " € " +
                                    _vm._s(
                                      _vm._f("formatNumberNoDecimals")(15000)
                                    ) +
                                    "  "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(7)
                        ])
                      ])
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "back vaillantCont scrollContainer" }, [
            _vm._m(8),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _c("ul", { staticClass: "newBackDesc text-left pt-md-4 " }, [
              _c("li", [
                _vm._v("\n            Valore nominale di cessione: "),
                _c("b", [
                  _vm._v(_vm._s(100 - _vm.finance_cost_agileenergy) + "%*")
                ]),
                _vm._v(" a carico del committente\n            "),
                _c("br"),
                _vm._v(
                  " (* potenzialmente soggetto ad eventuali variazioni da parte di AGILE ENERGY)\n          "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._m(10),
                _vm._v(" (importo Pratica base)\n            "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA ≤ € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. ( Edilizia Libera o NO Edilizia Libera )"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence e comunicazione web cessione credito da cliente ad installatore: "
                ),
                _c("b", [
                  _vm._v("€" + _vm._s(_vm.practic_price_mbfacta_old) + "+IVA")
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA > € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. ma ≤ 15.000 IVA incl. "
                  ),
                  _c("b", { staticClass: "red" }, [
                    _vm._v("SOLO Edilizia Libera")
                  ])
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione credito da cliente ad installatore: "
                ),
                _c("b", [
                  _vm._v("€" + _vm._s(_vm.practic_price_mbfacta_old) + "+IVA")
                ])
              ]),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              _vm._m(13),
              _vm._v(" "),
              _vm._m(14)
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "center h5 mb-0 pb-0" }, [
              _vm._v("Requisiti per cessione ad AGILE ENERGY: ")
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "newBackDesc text-left pt-2 pb-0" }, [
              _c("li", [
                _vm._v("\n            Requisiti base PMI "),
                _c(
                  "b",
                  {
                    staticClass: "underline pointer",
                    on: {
                      click: function($event) {
                        return _vm.setSection(3)
                      }
                    }
                  },
                  [_vm._v("(elenco QUI)")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("\n            Inserimento documenti per "),
                _c("b", [
                  _vm._v("verifica Criteri di Eleggibilità AGILE ENERGY")
                ]),
                _vm._v(
                  " (inserimento e attesa validazione documenti nella sezione Documenti per Eleggibilità Agile Energy "
                ),
                _c(
                  "b",
                  {
                    staticClass: "underline pointer",
                    on: {
                      click: function($event) {
                        return _vm.setSection(3)
                      }
                    }
                  },
                  [_vm._v("cliccando\n              QUI")]
                ),
                _vm._v(")\n          ")
              ]),
              _vm._v(" "),
              _vm._m(15)
            ])
          ]),
          _vm._v(" "),
          _c("div", { ref: "agileenergy", staticClass: "cardFooter" }, [
            _vm.card4
              ? _c(
                  "h5",
                  {
                    staticClass: "pointer mb-2 pb-2 mt-2",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(4)
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-3",
                      attrs: { icon: "arrow-left", size: "1x" }
                    }),
                    _vm._v(" Indietro\n        ")
                  ],
                  1
                )
              : _c(
                  "h5",
                  {
                    staticClass: "pointer mb-2 pb-2 mt-2",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(4)
                      }
                    }
                  },
                  [
                    _vm._v("Scopri di piu\n          "),
                    _c("font-awesome-icon", {
                      staticClass: "ml-3",
                      attrs: { icon: "arrow-right", size: "1x" }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.hasSelectButtons &&
            _vm.flow_ae_active &&
            _vm.aeState == "active"
              ? _c(
                  "h5",
                  {
                    staticClass: "center underline pointer brTop mt-0 pt-2",
                    on: {
                      click: function($event) {
                        return _vm.setChoice("agileenergy")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mt-2" }, [
                      _vm._v("Procedi con AGILE ENERGY")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSelectButtons &&
            _vm.flow_ae_active &&
            _vm.aeState != "active"
              ? _c(
                  "h5",
                  {
                    staticClass:
                      "center disabled red pointer brTop mt-0 pt-2 smallTxt"
                  },
                  [
                    _c("span", { staticClass: "mt-2 Bold" }, [
                      _vm._v("Puoi procedere solo se il flusso è abilitato ")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSelectButtons && !_vm.flow_ae_active
              ? _c("h5", {
                  staticClass:
                    "center  pointer brTop mt-0 pt-2 black smallTxt ",
                  attrs: { disabled: "" },
                  domProps: { innerHTML: _vm._s(_vm.ae_not_active_text) }
                })
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cardBox mb-4", class: { "is-flipped": _vm.card3 } },
      [
        _c("div", { staticClass: "cardFlow" }, [
          _c("div", { staticClass: "front vaillantCont" }, [
            _vm._m(16),
            _vm._v(" "),
            _vm._m(17),
            _vm._v(" "),
            _c(
              "h4",
              {
                staticClass: "mt-0 pt-0",
                class: {
                  "pb-md-0":
                    _vm.cdpState == "pending" || _vm.cdpState == "active"
                }
              },
              [_vm._m(18)]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row justify-content-center text-center" },
                [
                  _vm._m(19),
                  _vm._v(" "),
                  _vm._m(20),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
                    [
                      _c("div", { staticClass: "quardContainer bluetify" }, [
                        _c("div", { staticClass: "quardDescription" }, [
                          _c(
                            "h1",
                            {
                              staticClass:
                                "quardValue center h2  mt-2 pt-0 mb-0"
                            },
                            [
                              _c(
                                "b",
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "user-check", size: "1x" }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(21)
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(22)
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "back vaillantCont scrollContainer" }, [
            _vm._m(23),
            _vm._v(" "),
            _vm._m(24),
            _vm._v(" "),
            _c("ul", { staticClass: "newBackDesc text-left pt-md-4 " }, [
              _vm._m(25),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("Costo Pratica")]),
                _vm._v(" (importo Pratica base)\n            "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA ≤ € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. o Edilizia Libera"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence e comunicazione web cessione crediti da committente ad aderente: "
                ),
                _c("b", [_vm._v("€230+IVA")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "TQSA > € " +
                      _vm._s(_vm.tqsa) +
                      " IVA incl. e NO Edilizia Libera"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "Totale Quota Spesa Agevolabile;\n            importo Pratica base; include Due Diligence, Visto di Conformità e comunicazione web cessione crediti da committente ad aderente: "
                ),
                _c("b", [_vm._v("€290+IVA")])
              ]),
              _vm._v(" "),
              _vm._m(26),
              _vm._v(" "),
              _vm._m(27),
              _vm._v(" "),
              _vm._m(28)
            ])
          ]),
          _vm._v(" "),
          _c("div", { ref: "agen", staticClass: "cardFooter" }, [
            _vm.card3
              ? _c(
                  "h5",
                  {
                    staticClass: "pointer ",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(3)
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-3",
                      attrs: { icon: "arrow-left", size: "1x" }
                    }),
                    _vm._v(" Indietro\n        ")
                  ],
                  1
                )
              : _c(
                  "h5",
                  {
                    staticClass: "pointer mb-2 pb-2 mt-2",
                    class: {
                      "mt-1 pt-1 mb-0 pb-0": _vm.hasSelectButtons,
                      "mb-2 pb-2 mt-2": !_vm.hasSelectButtons
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleCard(3)
                      }
                    }
                  },
                  [
                    _vm._v("Scopri di piu\n          "),
                    _c("font-awesome-icon", {
                      staticClass: "ml-3",
                      attrs: { icon: "arrow-right", size: "1x" }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.hasSelectButtons
              ? _c(
                  "h5",
                  {
                    staticClass: "center underline pointer brTop mt-0 pt-2",
                    on: {
                      click: function($event) {
                        return _vm.setChoice("general")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "mt-2" }, [
                      _vm._v("Procedi con Flusso Base")
                    ])
                  ]
                )
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", { staticClass: "uppercase" }, [_vm._v("Agile Energy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "center h5 mt-2 mb-2 mb-md-3 uppercase" }, [
      _c("b", [_vm._v("Flusso General Contractor "), _c("small")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
      _c("b", [_vm._v("Valore  nominale  di cessione  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "quardDescription mt-0 pt-0 center mb-0 red" },
      [
        _c("b", [
          _vm._v("Potenzialmente soggetto "),
          _c("br"),
          _vm._v("ad eventuali variazioni  ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [_c("b", [_vm._v("+IVA")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
      _c("b", [
        _vm._v("Costo Pratica "),
        _c("br"),
        _vm._v(" per il committente "),
        _c("br"),
        _vm._v(" con Due Diligence  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription center mb-0" }, [
      _c("b", [
        _vm._v("Verifica Criteri di Eleggibilità "),
        _c("br"),
        _vm._v(" AGILE ENERGY")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription center mb-0" }, [
      _c("b", [
        _vm._v("Importo massimo  fattura"),
        _c("br"),
        _vm._v("  per intervento ( Edilizia Libera )  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", { staticClass: "uppercase" }, [_vm._v("AGILE ENERGY")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "center h5 mt-2 mb-2 mb-2 mb-md-3 Bold" }, [
      _c("b", [_vm._v("FLUSSO COMPLETO GENERAL CONTRACTOR")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("Costo Pratica Base al commitente "),
      _c("b", { staticClass: "red" }, [
        _vm._v("esclusi costi di gestione e servizi AGILE ENERGY")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("b", [
        _vm._v(
          "Costo di gestione e servizi AGILE ENERGY a carico dell'installatore in subappalto: "
        ),
        _c("b", { staticClass: "green" }, [_vm._v("  €300+IVA")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Riferimento Bonus Fiscali: "),
      _c("b", [_vm._v("EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Partner: "),
      _c("b", [_vm._v("AGILE ENERGY")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Tempo medio di liquidazione:\n              "),
      _c("br"),
      _vm._v("- Primo Pagamento: "),
      _c("b", [
        _vm._v(
          "30% del TOTALE IMPONIBILE INTERVENTO a Rimessa Diretta dopo validazione documentale e Due Diligence da parte dell'Advisor incaricato "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v("- Saldo Pagamento "),
      _c("b", [
        _vm._v(
          "70% del TOTALE IMPONIBILE INTERVENTO a 30 giorni D.F.F.M. da credito disponibile nel cassetto fiscale di AGILE ENERGY"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        " (** potenzialmente soggetto ad eventuali variazioni da parte di AGILE ENERGY)\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Sottoscrizione del "),
      _c("b", [_vm._v("contratto di Subappalto con AGILE ENERGY")]),
      _vm._v(" per ogni Pratica\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", [_vm._v("Flusso BASE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "center h5 mt-2 mb-2 mb-md-3 uppercase red Bold" },
      [_c("b", [_vm._v("Senza Cessione del Credito")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v(" Stato :\n            "),
      _c("span", { staticClass: "green  " }, [_vm._v(" Abilitato ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 center text-center pr-2 pl-2 mt-2" },
      [
        _c("div", { staticClass: "quardContainer bluetify" }, [
          _c("div", { staticClass: "quardDescription" }, [
            _c("h1", { staticClass: "quardValue mt-2 pt-0 mb-0 center h2 " }, [
              _c("b", [_vm._v("XX %")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
              _c("b", [_vm._v("Valore nominale di cessione ")])
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "quardDescription mt-0 pt-0 center mb-0 red uppercase"
              },
              [
                _c("b", [
                  _vm._v("modificabile liberalmente "),
                  _c("br"),
                  _vm._v(" dall'aderente  ")
                ])
              ]
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 center text-center pr-2 pl-2 mt-1 mt-md-2" },
      [
        _c("div", { staticClass: "quardContainer bluetify" }, [
          _c("p", { staticClass: "quardDescription mt-2 pt-0 center mb-0" }, [
            _c("b", [_vm._v("a partire da"), _c("br")])
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "quardValue mt-0 pt-0 mb-0 center h2 " }, [
            _c("b", {}, [
              _vm._v(" € 230"),
              _c("small", [_c("b", [_vm._v("+IVA")])])
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "quardDescription mt-0 pt-0 center mb-0" }, [
            _c("b", [
              _vm._v("Costo Pratica Base (*) "),
              _c("br"),
              _vm._v(" con Due Diligence  ")
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "quardDescription center mb-0" }, [
      _c("b", [_vm._v("Senza "), _c("br"), _vm._v(" Criteri di Eleggibilità")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-6 center  text-center pr-2 pl-2 mt-2" },
      [
        _c("div", { staticClass: "quardContainer bluetify" }, [
          _c("div", { staticClass: "quardDescription" }, [
            _c("p", { staticClass: "quardDescription center mb-0" }, [
              _c("b", [
                _vm._v("Creazione "),
                _c("br"),
                _vm._v(" Preventivi e Pratiche "),
                _c("br"),
                _vm._v("con comunicazione web cessione credito "),
                _c("br"),
                _vm._v(" da cliente ad installatore ")
              ])
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular h2 widthFull mt-0 flowTitle" }, [
      _c("b", [_vm._v("Flusso BASE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "center h5 mt-2 mb-2 mb-md-3 uppercase red Bold" },
      [_c("b", [_vm._v("Senza Cessione del Credito")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Valore nominale standart di cessione: "),
      _c("b", [_vm._v("XX %*")]),
      _vm._v(" "),
      _c("p", { staticClass: "quardDescription mt-0 pt-0  mb-0 red " }, [
        _c("b", [_vm._v("modificabile liberalmente dall'aderente  ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Riferimento Bonus Fiscali: "),
      _c("b", [_vm._v("EcoBonus 65%, EcoBonus 50%, Bonus Casa 50%")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("\n            Advisor: "),
      _c("b", [_vm._v("ADVISOR PARTNER")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("b", { staticClass: "red" }, [
        _vm._v("FLUSSO SENZA CESSIONE DEL CREDITO ")
      ]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26cc6f77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cc6f77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowSettings/flows.vue
// module id = null
// module chunks = 